import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'rsuite/dist/rsuite.min.css';
import '@/common/view/globals.scss';
import '@/common/view/global_tailwind.css';
import '@/common/agent/i18n';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GlobalSWRConfig } from '@/common/agent/swr';
import { AuthProvider } from '@/auth/signin/datacontroller/AuthContext';
import { ThemeProvider } from '@/common/view/theme/context';
import App from './main/controller/App';
import reportWebVitals from './main/util/ReportWebVitalsUtil';

// replace console.* for disable log on production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}
// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 2,
      retryDelay: 1000,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <GlobalSWRConfig>
            <RecoilRoot>
              <AuthProvider>
                <App />
              </AuthProvider>
            </RecoilRoot>
          </GlobalSWRConfig>
        </QueryClientProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

console.info(`🦉 App version: ${process.env.REACT_APP_VERSION}`);
